import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import styled from 'styled-components'

export const BodyModal = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  padding: 30px 40px;
`

export const ContainerButton = styled.div`
  display: flex;
  text-transform: uppercase;
  justify-content: space-around;
  flex: 1 1 100%;
  margin: 44px 0 0.5rem;
`

export const InfoContainer = styled.div`
  border-radius: 0px 8px 8px 0px;
  border-left: ${({ theme }) => `3px solid ${theme.colors.blue}`};
  padding: 5px 20px;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 4px;
`

export const Form = styled.div`
  margin: 0;
`

export const ModalMessage = styled.h6`
  text-align: center;
`
export const EditIcon = styled(EditOutlinedIcon)`
    color: ${({ theme }) => theme.colors.white} !important;
`
